import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_CONTRACT_TYPES: (id) => ({
        url: `contracttypes?iCommunityId=${id}`,
        method: "get",
    }),

    SAVE_OR_UPDATE: {
        url: "verzoeken/save-or-update-admin-community",
        method: 'post',
    },
        GET_VERVANGER_DATA: {
        url: "verzoeken/replace-user-list",
        method: "get",
    },

};

export const useContractTypes = (
    communityId,
    adminId,
    enabled = true
) =>
    useApiFetcherSWR(
        enabled && communityId
            ? API_ENDPOINT.GET_CONTRACT_TYPES(communityId)
            : null
    );

export const useSaveOrUpdate = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_OR_UPDATE);

export const useVervangerData = ( pageSize, page, search, sortKey, sortOrder, communityId, enabled = true) =>
    useApiFetcherSWR(
        enabled && communityId
            ? {
                  ...API_ENDPOINT.GET_VERVANGER_DATA,
                  params: {
                      pageSize,page,search,sortKey,sortOrder,iCommunityId: communityId,
                  },
              }
            : null
    );